import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=30bf6c74&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=ts"
export * from "./FooterLinks.vue?vue&type=script&lang=ts"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=30bf6c74&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf6c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bf6c74')) {
      api.createRecord('30bf6c74', component.options)
    } else {
      api.reload('30bf6c74', component.options)
    }
    module.hot.accept("./FooterLinks.vue?vue&type=template&id=30bf6c74&scoped=true", function () {
      api.rerender('30bf6c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Landing/FooterLinks.vue"
export default component.exports